{
  "route": "earth2",
  "railEntries": [
    {
      "label": "Declaration",
      "anchor": "earth2-section-1"
    },
    {
      "label": "Mandate",
      "anchor": "earth2-section-2"
    },
    {
      "label": "The room",
      "anchor": "earth2-section-3"
    },
    {
      "label": "Case method",
      "anchor": "earth2-section-4"
    },
    {
      "label": "Threshold",
      "anchor": "earth2-section-5"
    },
    {
      "label": "Assessment",
      "anchor": "earth2-section-6"
    },
    {
      "label": "Refusals",
      "anchor": "earth2-section-7"
    }
  ],
  "anchors": [
    "earth2-section-1",
    "earth2-section-2",
    "earth2-section-3",
    "earth2-section-4",
    "earth2-section-5",
    "earth2-section-6",
    "earth2-section-7"
  ],
  "nodes": [
    {
      "tag": "section",
      "attrs": {
        "class": "route chapter earth2-chapter",
        "id": "route-earth2",
        "aria-labelledby": "earth2-title"
      },
      "children": [
        {
          "tag": "div",
          "attrs": {
            "class": "wrap"
          },
          "children": [
            {
              "tag": "header",
              "attrs": {
                "class": "chapter-hero"
              },
              "children": [
                {
                  "tag": "div",
                  "children": [
                    {
                      "tag": "span",
                      "attrs": {
                        "class": "chapter-index"
                      },
                      "children": [
                        "02 · The Crossing"
                      ]
                    },
                    " ",
                    {
                      "tag": "h1",
                      "attrs": {
                        "id": "earth2-title"
                      },
                      "children": [
                        "Earth 2.0 & ",
                        {
                          "tag": "em",
                          "children": [
                            "the declaration."
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "chapter-deck"
                      },
                      "children": [
                        "Your architecture for turning readiness into a durable mandate: the right case, the right room, real information, shared investment and a system capable of continuing after the steward leaves."
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "aside",
                  "attrs": {
                    "class": "chapter-aside"
                  },
                  "children": [
                    {
                      "tag": "strong",
                      "children": [
                        "Source posture"
                      ]
                    },
                    "This chapter preserves your supplied declaration as your authored model. Its practice claims are treated as propositions until pilots generate independent evidence."
                  ]
                },
                " "
              ]
            },
            " ",
            {
              "tag": "div",
              "attrs": {
                "class": "chapter-body"
              },
              "children": [
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "earth2-section-1"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "quote-panel"
                      },
                      "children": [
                        {
                          "tag": "blockquote",
                          "children": [
                            "“I am here to change ",
                            {
                              "tag": "em",
                              "children": [
                                "how change happens."
                              ]
                            },
                            "”"
                          ]
                        },
                        {
                          "tag": "cite",
                          "children": [
                            "Nicole Lockwood · Earth 2.0 declaration · July 2026"
                          ]
                        }
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "earth2-section-2"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "section-intro"
                      },
                      "children": [
                        {
                          "tag": "p",
                          "attrs": {
                            "class": "section-label"
                          },
                          "children": [
                            "The causal claim"
                          ]
                        },
                        {
                          "tag": "h2",
                          "attrs": {
                            "class": "section-heading"
                          },
                          "children": [
                            "The scarce resource is not ideas. ",
                            {
                              "tag": "em",
                              "children": [
                                "The mandate is missing."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "lead"
                      },
                      "children": [
                        "Systems routinely follow “catastrophe first, movement second.” Earth 2.0 proposes a structure through which a place can see, decide, fund, implement and learn together before crisis removes the luxury of choice."
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "panel-grid three"
                      },
                      "children": [
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel accent"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label model"
                              },
                              "children": [
                                "Your model"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "Earth 2.0"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "The architecture: collaborative democracy made operational around a real case."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel accent"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label model"
                              },
                              "children": [
                                "Your model"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "The Threshold"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "The physics: readiness-timed movement through Sense · Design · Shift · Stay."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel accent"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label model"
                              },
                              "children": [
                                "Your terms"
                              ]
                            },
                            {
                              "tag": "h3",
                              "children": [
                                "The stewardship"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "Mandate, proof, shared engine, fair exchange and enough room for life."
                              ]
                            }
                          ]
                        },
                        " "
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "earth2-section-3"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "section-intro"
                      },
                      "children": [
                        {
                          "tag": "p",
                          "attrs": {
                            "class": "section-label"
                          },
                          "children": [
                            "The original room"
                          ]
                        },
                        {
                          "tag": "h2",
                          "attrs": {
                            "class": "section-heading"
                          },
                          "children": [
                            "Six seats. No seat ",
                            {
                              "tag": "em",
                              "children": [
                                "formally above another."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "seat-grid",
                        "aria-label": "The six original Earth 2.0 seats"
                      },
                      "children": [
                        {
                          "tag": "div",
                          "attrs": {
                            "class": "seat"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "children": [
                                {
                                  "tag": "small",
                                  "children": [
                                    "01"
                                  ]
                                },
                                "Industry"
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "div",
                          "attrs": {
                            "class": "seat"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "children": [
                                {
                                  "tag": "small",
                                  "children": [
                                    "02"
                                  ]
                                },
                                "Community"
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "div",
                          "attrs": {
                            "class": "seat"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "children": [
                                {
                                  "tag": "small",
                                  "children": [
                                    "03"
                                  ]
                                },
                                "Government"
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "div",
                          "attrs": {
                            "class": "seat"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "children": [
                                {
                                  "tag": "small",
                                  "children": [
                                    "04"
                                  ]
                                },
                                "Academia"
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "div",
                          "attrs": {
                            "class": "seat"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "children": [
                                {
                                  "tag": "small",
                                  "children": [
                                    "05"
                                  ]
                                },
                                "Capital"
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "div",
                          "attrs": {
                            "class": "seat"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "children": [
                                {
                                  "tag": "small",
                                  "children": [
                                    "06"
                                  ]
                                },
                                "Philanthropy"
                              ]
                            }
                          ]
                        },
                        " "
                      ]
                    },
                    " ",
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "footnote"
                      },
                      "children": [
                        "Earth 3.0 retains the system-spanning intent, but does not mistake sector presence for legitimacy. First Peoples are rights-holders through their own governance; affected people, labour, future generations and the living world require explicit standing."
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "earth2-section-4"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "section-intro"
                      },
                      "children": [
                        {
                          "tag": "p",
                          "attrs": {
                            "class": "section-label"
                          },
                          "children": [
                            "The case method"
                          ]
                        },
                        {
                          "tag": "h2",
                          "attrs": {
                            "class": "section-heading"
                          },
                          "children": [
                            "From shared need to ",
                            {
                              "tag": "em",
                              "children": [
                                "capacity that stays."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "ol",
                      "attrs": {
                        "class": "number-list"
                      },
                      "children": [
                        {
                          "tag": "li",
                          "children": [
                            {
                              "tag": "strong",
                              "children": [
                                "Choose the case"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Select acknowledged need and real momentum, not the grandest possible issue."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "li",
                          "children": [
                            {
                              "tag": "strong",
                              "children": [
                                "Curate the room"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Bring those whose authority, knowledge, consent and labour determine the result."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "li",
                          "children": [
                            {
                              "tag": "strong",
                              "children": [
                                "Table the real information"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Make complexity usable. Separate fact, uncertainty, value and interest."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "li",
                          "children": [
                            {
                              "tag": "strong",
                              "children": [
                                "Co-create the plan"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Stage the transition, roles, commitments and trade-offs together."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "li",
                          "children": [
                            {
                              "tag": "strong",
                              "children": [
                                "Fund it together"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Pool investment while preventing money from purchasing the outcome."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "li",
                          "children": [
                            {
                              "tag": "strong",
                              "children": [
                                "Implement together"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Move through visible sprints with accountable delivery, not endless convening."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "li",
                          "children": [
                            {
                              "tag": "strong",
                              "children": [
                                "Measure and show"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Track social, economic and ecological outcomes; publish what changes."
                              ]
                            }
                          ]
                        },
                        " "
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "earth2-section-5"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "section-intro"
                      },
                      "children": [
                        {
                          "tag": "p",
                          "attrs": {
                            "class": "section-label"
                          },
                          "children": [
                            "The Threshold"
                          ]
                        },
                        {
                          "tag": "h2",
                          "attrs": {
                            "class": "section-heading"
                          },
                          "children": [
                            "Readiness before access. ",
                            {
                              "tag": "em",
                              "children": [
                                "Steward, not judge."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "table",
                      "attrs": {
                        "class": "comparison"
                      },
                      "children": [
                        {
                          "tag": "thead",
                          "children": [
                            {
                              "tag": "tr",
                              "children": [
                                {
                                  "tag": "th",
                                  "children": [
                                    "Spine"
                                  ]
                                },
                                {
                                  "tag": "th",
                                  "children": [
                                    "Purpose"
                                  ]
                                },
                                {
                                  "tag": "th",
                                  "children": [
                                    "Operating question"
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "tbody",
                          "children": [
                            {
                              "tag": "tr",
                              "children": [
                                {
                                  "tag": "td",
                                  "children": [
                                    "Sense"
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Read the field, its people, power, pressure and current capacity."
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "What is actually ready, and what is merely urgent?"
                                  ]
                                }
                              ]
                            },
                            " ",
                            {
                              "tag": "tr",
                              "children": [
                                {
                                  "tag": "td",
                                  "children": [
                                    "Design"
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Compose the room, evidence, authority and conditions for movement."
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Who must consent, decide, contribute and be protected?"
                                  ]
                                }
                              ]
                            },
                            " ",
                            {
                              "tag": "tr",
                              "children": [
                                {
                                  "tag": "td",
                                  "children": [
                                    "Shift"
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Use a bounded intervention to move behaviour, resources and commitments."
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "What becomes newly possible at this threshold?"
                                  ]
                                }
                              ]
                            },
                            " ",
                            {
                              "tag": "tr",
                              "children": [
                                {
                                  "tag": "td",
                                  "children": [
                                    "Stay"
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Transfer capability and keep learning after the catalyst exits."
                                  ]
                                },
                                {
                                  "tag": "td",
                                  "children": [
                                    "Can the system hold the change without you?"
                                  ]
                                }
                              ]
                            },
                            " "
                          ]
                        },
                        " "
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "earth2-section-6"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "section-intro"
                      },
                      "children": [
                        {
                          "tag": "p",
                          "attrs": {
                            "class": "section-label"
                          },
                          "children": [
                            "Assessment"
                          ]
                        },
                        {
                          "tag": "h2",
                          "attrs": {
                            "class": "section-heading"
                          },
                          "children": [
                            "The soul is landed. The next work is ",
                            {
                              "tag": "em",
                              "children": [
                                "institutional engineering."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "panel-grid"
                      },
                      "children": [
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel accent"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label synthesis"
                              },
                              "children": [
                                "What is strong"
                              ]
                            },
                            {
                              "tag": "h2",
                              "children": [
                                "The differentiated centre"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "You construct anticipatory mandate through readiness-timed, cross-system transition stewardship. That is more precise than facilitator, strategist or advocate."
                              ]
                            },
                            {
                              "tag": "ul",
                              "attrs": {
                                "class": "plain-list"
                              },
                              "children": [
                                {
                                  "tag": "li",
                                  "children": [
                                    "Clear mission and ethical posture"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Practical seven-stage case architecture"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Earned, pilot-to-scale pathway"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Capacity transfer as the exit condition"
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel accent"
                          },
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "evidence-label synthesis"
                              },
                              "children": [
                                "What must be engineered"
                              ]
                            },
                            {
                              "tag": "h2",
                              "children": [
                                "Power beneath the room"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "Equal seats do not create equal power. A real operating model needs:"
                              ]
                            },
                            {
                              "tag": "ul",
                              "attrs": {
                                "class": "plain-list"
                              },
                              "children": [
                                {
                                  "tag": "li",
                                  "children": [
                                    "Rights, representation and participant resourcing"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Decision rules, vetoes, conflict and appeal"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Delegated authority, liability and accountability"
                                  ]
                                },
                                {
                                  "tag": "li",
                                  "children": [
                                    "Evidence, data, funding, IP and outcome protocols"
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        " "
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "section",
                  "attrs": {
                    "class": "section-block",
                    "id": "earth2-section-7"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "section-intro"
                      },
                      "children": [
                        {
                          "tag": "p",
                          "attrs": {
                            "class": "section-label"
                          },
                          "children": [
                            "The refusals"
                          ]
                        },
                        {
                          "tag": "h2",
                          "attrs": {
                            "class": "section-heading"
                          },
                          "children": [
                            "Guardrails already hiding ",
                            {
                              "tag": "em",
                              "children": [
                                "inside the declaration."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "axiom-list"
                      },
                      "children": [
                        {
                          "tag": "div",
                          "attrs": {
                            "class": "axiom"
                          },
                          "children": [
                            {
                              "tag": "b",
                              "children": [
                                "01"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "No single owner or hero."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "div",
                          "attrs": {
                            "class": "axiom"
                          },
                          "children": [
                            {
                              "tag": "b",
                              "children": [
                                "02"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Funding does not buy the outcome."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "div",
                          "attrs": {
                            "class": "axiom"
                          },
                          "children": [
                            {
                              "tag": "b",
                              "children": [
                                "03"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "No certainty theatre."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "div",
                          "attrs": {
                            "class": "axiom"
                          },
                          "children": [
                            {
                              "tag": "b",
                              "children": [
                                "04"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "No false urgency or simplicity."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "div",
                          "attrs": {
                            "class": "axiom"
                          },
                          "children": [
                            {
                              "tag": "b",
                              "children": [
                                "05"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "No forcing before readiness."
                              ]
                            }
                          ]
                        },
                        " ",
                        {
                          "tag": "div",
                          "attrs": {
                            "class": "axiom"
                          },
                          "children": [
                            {
                              "tag": "b",
                              "children": [
                                "06"
                              ]
                            },
                            {
                              "tag": "span",
                              "children": [
                                "Hosted, stewarded and handed on."
                              ]
                            }
                          ]
                        },
                        " "
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "button",
                  "attrs": {
                    "class": "route-next",
                    "type": "button",
                    "data-go": "stars"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "children": [
                        "Next field"
                      ]
                    },
                    {
                      "tag": "span",
                      "children": [
                        "I Eat the Stars · The Ground →"
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "footer",
                  "attrs": {
                    "class": "tiny-footer"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "children": [
                        "02 · Earth 2.0"
                      ]
                    },
                    {
                      "tag": "span",
                      "children": [
                        "Architecture + physics + stewardship"
                      ]
                    }
                  ]
                },
                " "
              ]
            },
            " "
          ]
        },
        " "
      ]
    },
    " "
  ]
}
